var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9366 16.0255C10.9366 15.4725 11.3836 15.0205 11.9366 15.0205C12.4896 15.0205 12.9366 15.4635 12.9366 16.0155L12.9366 16.0255C12.9366 16.5785 12.4896 17.0255 11.9366 17.0255C11.3836 17.0255 10.9366 16.5785 10.9366 16.0255Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9366 12.0157C10.9366 11.4627 11.3836 11.0117 11.9366 11.0117C12.4896 11.0117 12.9366 11.4537 12.9366 12.0067L12.9366 12.0157C12.9366 12.5687 12.4896 13.0157 11.9366 13.0157C11.3836 13.0157 10.9366 12.5687 10.9366 12.0157Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9366 8.00695C10.9366 7.45395 11.3836 7.00195 11.9366 7.00195C12.4896 7.00195 12.9366 7.44495 12.9366 7.99795L12.9366 8.00695C12.9366 8.55995 12.4896 9.00695 11.9366 9.00695C11.3836 9.00695 10.9366 8.55995 10.9366 8.00695Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreV);
export default __webpack_public_path__ + "static/media/More-V.79d4b4d2.svg";
export { ForwardRef as ReactComponent };